import { types, isType } from "mobx-state-tree"
export const Category = types.model({
    _id: types.identifier,
    title: types.string,
    logoUrl: types.string,
    leagues: types.array(types.string),
    picUrls: types.optional(types.array(types.string), [])
});


// WEBPACK FOOTER //
// ./src/models/Category.js